import React from "react";
import { Sparkles, ArrowRight, X } from "lucide-react";
import { useLanguage } from "../../context/LanguageProvider";

const AnnouncementBanner: React.FC = () => {
  const [isVisible, setIsVisible] = React.useState(true);
  const { t } = useLanguage();

  if (!isVisible) return null;

  return (
    <div className="relative z-50 bg-gradient-to-r from-emerald-600 via-teal-600 to-emerald-700 text-white text-xs sm:text-sm font-medium py-2 px-3 sm:px-4 shadow-md w-full overflow-hidden">
      <div className="max-w-7xl mx-auto flex items-center justify-between gap-2">
        <div className="flex items-center flex-wrap gap-x-2 gap-y-1 flex-1 justify-center text-center">
          <span className="inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-black uppercase tracking-wider bg-white/20 text-white border border-white/30 flex-shrink-0">
            {t("banner_tag") || "NOUVEAUTÉ"}
          </span>
          <span className="flex items-center gap-1 font-bold text-xs sm:text-sm leading-tight">
            <Sparkles className="w-3.5 h-3.5 text-amber-300 animate-pulse hidden sm:inline flex-shrink-0" />
            <span>
              {t("banner_text") || "FUKKONI Lite est Disponible ! Créez votre boutique Bio Link Instagram & WhatsApp en 60s — 100% Gratuit à Vie."}
            </span>
          </span>
          <a
            href="https://app.fukkoni.com/register?plan=lite"
            className="inline-flex items-center gap-1 font-black underline underline-offset-2 hover:text-amber-200 transition-colors ml-1 text-xs sm:text-sm whitespace-nowrap flex-shrink-0"
          >
            <span>{t("banner_cta") || "Créer ma Boutique Gratuite"}</span>
            <ArrowRight className="w-3.5 h-3.5" />
          </a>
        </div>
        <button
          onClick={() => setIsVisible(false)}
          className="text-white/80 hover:text-white p-1 rounded-lg hover:bg-white/10 transition-colors flex-shrink-0"
          aria-label="Dismiss banner"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default AnnouncementBanner;
